module.exports = __webpack_public_path__ + "static/media/ft-platform.8873225f.svg";